export default __webpack_public_path__ + "static/media/chi3.c3a0e094.jpg";